module.exports = __webpack_public_path__ + "img/Alert-bell.df0c43db.svg";